import { useFeatureChecks } from './feature-context';
import {
    ALLOWED_EVIDENCE_MIME_TYPES,
    ALLOWED_EVIDENCE_EXTENSIONS,
} from '../../constants/utility/file-upload.constants';

/**
 * Hook to get file upload constraints based on feature toggles
 * @returns {Object} File constraints with maxBytes, allowedMimes, allowedExts
 */
export const useFileConstraints = () => {
    const { useFeature } = useFeatureChecks();

    // Get feature-toggled values
    const maxSizeMb = useFeature('evidence.files.maxSizeMb', 25);
    const allowedFileTypes = useFeature('evidence.files.allowedFileTypes', true);

    // Convert MB to bytes
    const maxBytes = maxSizeMb * 1024 * 1024;

    // If file types are disabled, return empty arrays to block all uploads
    const allowedMimes = allowedFileTypes ? ALLOWED_EVIDENCE_MIME_TYPES : [];
    const allowedExts = allowedFileTypes ? ALLOWED_EVIDENCE_EXTENSIONS : [];

    return {
        maxBytes,
        allowedMimes,
        allowedExts,
        maxSizeMb, // Also return MB for display purposes
        allowedFileTypes, // Return the boolean flag
    };
};
